import { render, staticRenderFns } from "./MainViewGuide.vue?vue&type=template&id=c4c8373a&"
import script from "./MainViewGuide.vue?vue&type=script&lang=js&"
export * from "./MainViewGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports